import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@material-ui/core";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  Add,
  Edit,
  Delete,
} from "@material-ui/icons";
import TableDetail from "./TableDetail";
import ModalTK from "./ModalTK";
import CrudTK from "./CrudTK";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

function Row({ data, onOpenModal, onCrudTK }: any) {
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {data.place}
        </TableCell>
        <TableCell component="th" scope="row">
          {data.title_id}
        </TableCell>
        <TableCell>{data.title_en}</TableCell>
        <TableCell style={{ display: "flex", gap: 8 }}>
          <IconButton
            size="small"
            color="primary"
            onClick={() => onOpenModal("Edit", data)}
          >
            <Edit fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            color="primary"
            onClick={() => onOpenModal("Delete", data)}
          >
            <Delete fontSize="small" />
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <TableDetail
                data={data}
                onCrudTK={onCrudTK}
                // onCrudTK={() => onCrudTK({ id: data.id, title: data.title_id })}
              />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const initDataModal = {
  title_id: "",
  title_en: "",
  place: "0",
};

const initCrudTK = {
  open: false,
  action: "",
  title: "",
  data: null,
};

export default function TeknologiKami() {
  const [TKState, setTKState] = useState([]);
  const [TKCrud, setTKCrud] = useState(initCrudTK);
  const [actionModal, setActionModal] = useState("Add");
  const [openModal, setOpenModal] = useState(false);
  const [dataModal, setDataModal] = useState(initDataModal);

  const fetchContent = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_URL}/api/jlp/content/tk`
      );
      const resJson = await res.json();
      setTKState(resJson.data);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  const handleOpenModal = (action: string, data: any) => {
    setActionModal(action);
    setDataModal(data);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setDataModal(initDataModal);
  };

  const handleCrudTK = ({ title, action, data = null }: any) => {
    setTKCrud({ open: true, action, data, title });
  };

  useEffect(() => {
    fetchContent();
  }, [openModal]);

  return (
    <>
      {TKCrud.open && (
        <CrudTK
          onCancel={() => setTKCrud(initCrudTK)}
          action={TKCrud.action}
          data={TKCrud.data}
          title={TKCrud.title}
        />
      )}
      {!TKCrud.open && (
        <>
          <ModalTK
            open={openModal}
            onClose={handleCloseModal}
            action={actionModal}
            data={dataModal}
          />
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => handleOpenModal("Add", initDataModal)}
            startIcon={<Add />}
            style={{ marginBottom: 16 }}
          >
            Add
          </Button>
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>No.</TableCell>
                  <TableCell>Title ID</TableCell>
                  <TableCell>Title EN</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {TKState.length !== 0 ? (
                  TKState.map((row: any) => (
                    <Row
                      key={row.id}
                      data={row}
                      onOpenModal={handleOpenModal}
                      onCrudTK={handleCrudTK}
                    />
                  ))
                ) : (
                  <div style={{ padding: 16 }}>Data not found</div>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </>
  );
}
